import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { compact } from 'lodash';
import TextFieldWithInfo from 'src/components/TextField';
import MaskedInput from 'src/components/MaskedInput';
import RadioButtonGroup from 'src/components/RadioButtonGroup';
import DateTimePicker from 'src/components/DateTimePicker';
import {
  SolutionSourceImageRepoContainerType,
  SolutionSourceImageRepositoryItemField,
} from '../types';

export const getSourceImageRepositoryFormFields = (
  isEditMode: boolean,
  SOURCE_IMG_CONTAINER_REPO_TYPE_OPTIONS: any,
  ImagePullSecret: string,
  containerType?: string,
  handlePaste?: () => void,
  handleAcrClientSecretPaste?: () => void,
  handleEcrSecretKeyPaste?: () => void
) =>
  compact([
    {
      name: SolutionSourceImageRepositoryItemField.containerRepositoryType,
      label: 'Type',
      Component: RadioButtonGroup,
      value: containerType,
      initialValue: containerType,
      required: true,
      disabled: isEditMode && !containerType,
      options: SOURCE_IMG_CONTAINER_REPO_TYPE_OPTIONS,
    },
    containerType === SolutionSourceImageRepoContainerType.Acr && {
      name: SolutionSourceImageRepositoryItemField.acrSourceRepoName,
      label: 'Repository Name',
      Component: TextField,
      placeholder: 'Enter the name',
      required: true,
      disabled: isEditMode,
      validation: Yup.string().required('Repository Name is required'),
    },
    containerType === SolutionSourceImageRepoContainerType.Acr && {
      name: SolutionSourceImageRepositoryItemField.acrServerUrl,
      label: 'Server URL',
      Component: TextFieldWithInfo,
      required: true,
      showinfoicon: true,
      placeholder: 'Enter Container Registry URL',
      infotitle: 'Container registry URL',
      sx: { width: ({ spacing }) => spacing(55), paddingRight: '2rem' },
      validation: Yup.string().required('Server URL is required'),
    },
    containerType === SolutionSourceImageRepoContainerType.Acr && {
      name: SolutionSourceImageRepositoryItemField.sourcePullSecretUserName,
      label: 'Pull secret name',
      Component: TextFieldWithInfo,
      placeholder: 'Enter the username',
      showinfoicon: true,
      infotitle: 'Token name created in ACR',
      sx: { width: ({ spacing }) => spacing(55), paddingRight: '2rem' },
      required: true,
      validation: Yup.string().required('Username is required'),
    },
    containerType === SolutionSourceImageRepoContainerType.Acr && {
      name: SolutionSourceImageRepositoryItemField.sourcePullSecretPassword,
      label: 'Pull Secret',
      Component: MaskedInput,
      value: ImagePullSecret,
      placeholder: 'Enter the secret',
      onClickPasteIcon: handlePaste,
      showInfoIcon: true,
      infoTitle: 'Password created for token name',
      sx: { width: ({ spacing }) => spacing(55), paddingRight: '2rem' },
      required: true,
      icon: true,
      validation: Yup.string().required('PullSecret is required'),
    },
    containerType === SolutionSourceImageRepoContainerType.Acr && {
      name: SolutionSourceImageRepositoryItemField.secretExpiryDate,
      label: 'Secret Expiry Date',
      Component: DateTimePicker,
      placeholder: 'mm/dd/yyyy hh:mm',
      sx: { width: ({ spacing }) => spacing(55), paddingRight: '2rem' },
      required: false,
    },
    containerType === SolutionSourceImageRepoContainerType.Acr && {
      name: SolutionSourceImageRepositoryItemField.acrClientId,
      label: 'Client ID',
      Component: TextFieldWithInfo,
      placeholder: 'Enter the ID',
      showinfoicon: true,
      infotitle: 'Service principle name',
      sx: { width: ({ spacing }) => spacing(55), paddingRight: '2rem' },
      validation: Yup.string(),
    },
    containerType === SolutionSourceImageRepoContainerType.Acr && {
      name: SolutionSourceImageRepositoryItemField.acrClientSecretName,
      label: 'Client Secret',
      Component: MaskedInput,
      placeholder: 'Enter the secret',
      onClickPasteIcon: handleAcrClientSecretPaste,
      showInfoIcon: true,
      infoTitle: 'Service principle password',
      sx: { width: ({ spacing }) => spacing(55), paddingRight: '2rem' },
      icon: true,
      validation: Yup.string(),
    },
    containerType === SolutionSourceImageRepoContainerType.Ecr && {
      name: SolutionSourceImageRepositoryItemField.ecrSourceRepoName,
      label: 'Repository Name',
      Component: TextField,
      placeholder: 'Enter the name',
      required: true,
      disabled: isEditMode,
      validation: Yup.string().required('Repository Name is required'),
    },
    containerType === SolutionSourceImageRepoContainerType.Ecr && {
      name: SolutionSourceImageRepositoryItemField.ecrServerUrl,
      label: 'Server URL',
      Component: TextFieldWithInfo,
      required: true,
      showinfoicon: true,
      placeholder: 'Enter Container Registry URL',
      infotitle: 'Container registry URL',
      sx: { width: ({ spacing }) => spacing(55), paddingRight: '2rem' },
      validation: Yup.string().required('Server URL is required'),
    },
    containerType === SolutionSourceImageRepoContainerType.Ecr && {
      name: SolutionSourceImageRepositoryItemField.EcrAccesKey,
      label: 'Access key',
      Component: TextField,
      placeholder: 'Enter the Key',
      required: true,
      validation: Yup.string().required('Access Key is required'),
    },
    containerType === SolutionSourceImageRepoContainerType.Ecr && {
      name: SolutionSourceImageRepositoryItemField.EcrSecretKey,
      label: 'Secret key',
      Component: MaskedInput,
      placeholder: 'Enter the secret key',
      onClickPasteIcon: handleEcrSecretKeyPaste,
      required: true,
      icon: true,
      validation: Yup.string().required('Secret Key is required'),
    },
    containerType === SolutionSourceImageRepoContainerType.Ecr && {
      name: SolutionSourceImageRepositoryItemField.EcrRegionEndpoint,
      label: 'Region endpoint',
      Component: TextField,
      placeholder: 'Select the value',
      required: true,
      validation: Yup.string().required('Region endpoint is required'),
    },
  ]);
